module.exports = __webpack_public_path__ + "img/53ad586.gif";